import { Divider, Paper, useTheme } from '@mui/material';

import { NoteListItemsSupervisor } from './components/NoteListItemsSupervisor';
import { ViewOptionsSection } from './components/ViewOptionsSection';
import { useNoteListSidebarSupervisor } from './useNoteListSidebarSupervisor';

export const NoteListSidebarSupervisor = ({ leftWidth }: { leftWidth: number }) => {
  const theme = useTheme();

  const { notes, filterOptions } = useNoteListSidebarSupervisor();
  return (
    <Paper
      elevation={0}
      sx={{
        width: leftWidth,
        height: 'calc(100vh - 51px)',
        maxHeight: 'calc(100vh - 51px)',
        borderRight: `1px solid ${theme.palette.divider}`,
        position: 'sticky',
        top: 0,
        borderRadius: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <ViewOptionsSection filterOptions={filterOptions} />
      <Divider />
      <NoteListItemsSupervisor notes={notes} />
    </Paper>
  );
};
